import { useContext, useLayoutEffect, useRef, useState } from "react";
import { ForMnSteps, BurgerButtonBig, ButtonRound, DropdownInfo, HeaderBig, LearnMore, SignupBox, TabSwitch, LinkSmart } from "../common/Common";
import './HowItWorks.css';
import { LocaleContext, ScrollContext } from "../common/App";
import { Link } from "react-router-dom";
import { Footer, ForFamiliesSteps } from "./WebsiteCommon";
import { useNavigateSmart } from "../common/hooks";

export function HowItWorks(props) {
    const locale = useContext(LocaleContext);
    const navigate = useNavigateSmart();

    return (
        <div>
            <img className="img_width" src="/customer/02_header_how_it_works.jpg"></img>
            <div className="text_box">
                <div className="text_small">{locale.msgs.HOW_BROKERAGE_WORKS}</div>

                <div className="text_big_big margin_top_middle">{locale.msgs.HOW_IT_WORKS_2}</div>
                <div className="text">
                    <span dangerouslySetInnerHTML={{__html: locale.msgs.HOW_IT_WORKS_2_DESCR_1}} />
                    <LinkSmart className="link_2" to="/faq?question=14" /*target="_blank"*/>{locale.msgs.LEARN_MORE_2}</LinkSmart>
                    <div dangerouslySetInnerHTML={{__html: locale.msgs.HOW_IT_WORKS_2_DESCR_2}} />
                </div>
            </div>

            <div className="margin_top_low">
                <TabSwitch tabNames={[locale.msgs.FOR_FAMILIES, locale.msgs.FOR_M_N_SHORT]}
                            tabElements={[
                                <div className="steps_tab_box">
                                    <ForFamiliesSteps/>

                                    <div className="text_big_big margin_top_high">{locale.msgs.AMOUNT_OF_FEES}</div>
                                    <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.AMOUNT_OF_FEES_DESCR}}></div>

                                    <div className="margin_top_high">
                                        <SignupBox header={locale.msgs.FIND_MANNY_OR_NANNY} descr={locale.msgs.FIND_MANNY_OR_NANNY_DESCR_HOW_IT_WORKS}
                                                onClick={() => navigate("/register_fam") } />
                                    </div>
                                </div>
                                , 
                                <div className="steps_tab_box">
                                    <ForMnSteps/>

                                    <div className="margin_top_high">
                                        <SignupBox header={locale.msgs.FIND_JOB} descr={locale.msgs.FIND_JOB_DESCR_HOW_IT_WORKS}
                                                onClick={() => navigate("/register_mn") } />
                                    </div>
                                </div>
                            ]}
                            sameTabWidth={true}
                />
            </div>

            <div className="text_box margin_bottom_high"></div>

            <Footer />
        </div>
    );
}
